import React from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import Products from "../components/Products";

const AffordableDataPage = () => {
  const navigate = useNavigate();
  const { walletBalances, fetchBalance } = useOutletContext();

  const handleBack = () => {
    navigate("/dashboard");
    // Refresh balance when returning from products
    fetchBalance();
  };

  return (
    <Products
      category="affordable-data"
      onBack={handleBack}
      walletBalances={walletBalances}
      onBalanceUpdate={fetchBalance}
    />
  );
};

export default AffordableDataPage;
